import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Louisiana = () => {
  return (
    <StatePropertyTaxPage
      stateName="Louisiana"
      processDescription="Assessment rolls open around August 24–September 8 for approximately 15 days. Homeowners review values and discuss discrepancies with Assessor's Office. If unresolved, file a protest (Form 3101) to Parish Board of Review. If still unresolved, appeal to Louisiana Tax Commission."
      noticeOfValueMailed="August"
      noticeOfValueMailedDateExplanation="Assessment rolls are open in August for review and protest."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Valuation is set as of January 1 per Louisiana Constitution Article VII, Section 18 and Louisiana Revised Statutes 47:1974. This assessment date establishes the taxable value for the current year."
      deadlineExplanation="Property owners have 15 days from the date of notice posting/publication to file protests. The deadline is typically September 8, but this brief window requires prompt action to preserve appeal rights."
    />
  );
};

export default Louisiana;